import { useEffect, useRef, useState } from 'react';

import { courseMetadataApi } from '../api';
import type { CourseData } from '../types';

export function useCourseOutline(courseID: string, refresher?: number) {
  const [courseMetadata, setCourseMetadata] = useState<CourseData>({} as CourseData);
  const [courseMetadataLoaded, setCourseMetadataLoaded] = useState<boolean>(false);
  const [courseMetadataErrorStatus, setCourseMetadataErrorStatus] = useState<number | null>(null);
  const hasFetchedData = useRef<boolean>(false);

  useEffect(() => {
    if (hasFetchedData.current) {
      return;
    }
    setCourseMetadataErrorStatus(null);
    courseMetadataApi.getCourseMeta(
      courseID,
      (data) => {
        setCourseMetadata(data);
        setCourseMetadataLoaded(true);
      },
      (err) => {
        setCourseMetadataErrorStatus((err as { status?: number })?.status ?? null);
        setCourseMetadataLoaded(true);
      },
    );
    hasFetchedData.current = true;
  }, [refresher]);

  return {
    courseMetadata,
    courseMetadataErrorStatus,
    hasFetchedData,
    courseMetadataLoaded,
  };
}
